export function fmtEur(v: number): string {
  return v.toLocaleString('en-IE', { maximumFractionDigits: 0 });
}

export function pointsAttr(pts: [number, number][]): string {
  return pts.map(([x, y]) => x.toFixed(1) + ',' + y.toFixed(1)).join(' ');
}